export const BEGIN_FETCH_PLACE_DETAILS = 'BEGIN_FETCH_PLACE_DETAILS'
export const FETCH_PLACE_DETAILS_SUCCESS = 'FETCH_PLACE_DETAILS_SUCCESS'
